export default __webpack_public_path__ + "static/media/pricing-page-hero.8879721e.png";